import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AcademicYearContext = createContext();

export const AcademicYearProvider = ({ children }) => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [availableYears, setAvailableYears] = useState([currentYear]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAvailableYears = async () => {
      setLoading(true);
      try {
        const response = await api.get('/available-years/');
        const years = response.data.years || [currentYear];
        setAvailableYears(years);

        // Define o ano atual como selecionado se estiver na lista
        if (years.includes(currentYear)) {
          setSelectedYear(currentYear);
        } else if (years.length > 0) {
          // Caso contrário, seleciona o ano mais recente
          setSelectedYear(years[0]);
        }
      } catch (error) {
        console.error('Erro ao buscar anos letivos:', error);
        setAvailableYears([currentYear]);
        setSelectedYear(currentYear);
      } finally {
        setLoading(false);
      }
    };

    fetchAvailableYears();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AcademicYearContext.Provider
      value={{
        selectedYear,
        setSelectedYear,
        availableYears,
        loading,
        currentYear
      }}
    >
      {children}
    </AcademicYearContext.Provider>
  );
};

export const useAcademicYear = () => {
  const context = useContext(AcademicYearContext);
  if (!context) {
    throw new Error('useAcademicYear deve ser usado dentro de AcademicYearProvider');
  }
  return context;
};
